import { keepPreviousData, useQuery } from "@tanstack/react-query";

import {
  getDiagnosticChartOfAccounts,
  type CoaDiagnosticQuery,
} from "@/api/diagnostic-chart-of-accounts";
import { diagnosticKeys } from "@/hooks/useDiagnostic";

/**
 * As contas do plano de contas, para o drill-down do Diagnóstico (#1374 P2).
 *
 * A chave fica debaixo do prefixo do snapshot de propósito, como a da estrutura
 * organizacional: uma decisão salva no nó invalida `diagnosticKeys.snapshot` para
 * o quadro do Ato 1 mudar, e a lista é relida junto. Ao trocar de página ou de
 * filtro, a lista anterior fica na tela até a nova chegar.
 */
export function useDiagnosticChartOfAccounts(
  projectId: string | undefined,
  query: CoaDiagnosticQuery,
) {
  return useQuery({
    queryKey: [...diagnosticKeys.snapshot(projectId ?? ""), "chart-of-accounts", query] as const,
    queryFn: () => getDiagnosticChartOfAccounts(projectId!, query),
    enabled: !!projectId,
    staleTime: 30_000,
    placeholderData: keepPreviousData,
  });
}
